import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, TaskQueue, singleton, LogManager } from 'aurelia-framework';

export class ViewModelBase {

	className: string;

	logger = LogManager.getLogger("ViewModelModel");

	

	detached() {
		this.unsubscribeFromEvents();
	}

	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	eventSubscriptions: Array<Subscription> = [];

	constructor(public eventAggregator: EventAggregator) {
		this.logger.info("Constructor");
	}

	
}